// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"f0868de6","668":"e8be7af3","838":"3557c801"}[chunkId] + ".js";
};